import { describeBeaconHealth } from '@smarttransit/common'

export default {
  name: 'battery-level-indicator',
  props: {
    metadata: Object,
    size: {
      type: String,
      default: 'small'
    },
    showLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    described () {
      return describeBeaconHealth(this.metadata)
    },
    isVisible () {
      return Boolean(this.described)
    },
    statusLabel () {
      return this.described ? this.described.label : ''
    },
    color () {
      return this.described ? this.described.color : 'grey'
    },
    iconClass () {
      return this.described ? this.described.icon : 'far fa-battery-empty'
    },
    avatarSize () {
      return this.size === 'large' ? 35 : 18
    },
    tooltip () {
      return this.described ? this.described.detail : ''
    }
  }
}
